import { Table } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const TableStyled = styled(Table)`
  width: max(100%, 120rem);
`;
